export default [
  {
    path: '/b/sk-tim',
    redirect: '/b/sk-tim',
    name: 'bSkTim',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bSkTimIndex',
        component: () => import('@/views/b/skTim/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-sk-tim',
          pageTitle: 'SK Tim ',
          breadcrumb: [
            {
              text: 'SK Tim',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
